(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vector-tile-layer", [], factory);
	else if(typeof exports === 'object')
		exports["vector-tile-layer"] = factory();
	else
		root["vector-tile-layer"] = factory();
})(self, function() {
return 